<!-- Start Page Title Area -->
<div class="page-title-area page-title-bg1">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Customers</h2>
                    <ul>
                        <li><a href="https://ewns.in" itemprop="url" title="EWNS, Custom Ecommerce Platform to meet all your digital needs">Home</a></li>
                        <li>Customers</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/shape4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/shape5.png" alt="image"></div>
    <div class="shape-img7"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape-img8"><img src="assets/img/shape/shape8.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/shape9.png" alt="image"></div>
    <div class="shape-img10"><img src="assets/img/shape/shape10.png" alt="image"></div>
</div>
<!-- End Page Title Area -->

<!-- Start Blog Area -->
<section class="blog-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-md-12" *ngFor="let merchant of maskedMerchants">


                <div class="single-blog-post">
                    <div class="row">
                        <div class="col-md-3">
                            <a *ngIf="merchant.logo" href="{{merchant.url}}" title="{{merchant.name}}" itemprop="url">
                                <br/> <br/>
                                <img  itemprop="image" src="{{merchant.logoImage?.medium}}" alt="{{merchant.name}}">
                                <br/>
                            </a>
                            <a  *ngIf="!merchant.logo" href="{{merchant.url}}" title="{{merchant.name}}" itemprop="url">
                                <img itemprop="image" src="https://s3-ap-southeast-1.amazonaws.com/content-ewns/images/productimages/small/5fff3d958d5dbc10304de1bb.png" alt="{{merchant.name}}">
                            </a>
                        </div>

                        <div class="col-md-9">
                            <div class="post-content">
                                <div class="post-meta">
                                    <ul>
                                        <li>Category : <a href="{{merchant.url}}" title="{{merchant.name}}" itemprop="url">{{merchant.category}}</a></li>
                                        
                                    </ul>
                                </div>
                                <h3><a href="{{merchant.url}}" title="{{merchant.name}}" itemprop="url">{{merchant.name}}</a></h3>
                                <p *ngIf="merchant.shortBio">{{merchant.shortBio?.slice(0, 200)}}...</p>
                                <p *ngIf="!merchant.shortBio" innerHtml="{{merchant.description | slice:0:200 }}..."></p>
                            </div>
                          
                                <a href="{{merchant.url}}" title="{{merchant.name}}" itemprop="url" class="read-more-btn" style="color: #3a55ee; font-weight: 600;padding-left: 30px;">Visit Store <i class="flaticon-right-arrow"></i></a>
                        </div>
                    </div>
                    
                   
                   
                 
                </div>
            </div>
            
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="pagination-area">
                    <a href="{{this.prevLink}}" itemprop="url" title="Customers" class="prev page-numbers"><i class="fas fa-angle-double-left"></i></a>
                   
                    <a href="{{this.nextLink}}" itemprop="url" title="Customers" class="next page-numbers"><i class="fas fa-angle-double-right"></i></a>
                </div>
            </div>
        </div>

        
    </div>
</section>
<!-- End Blog Area -->
